module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1516-e7b388c7c5170adf65071a0c8c28c369.png";